<div
    class="group relative cursor-default rounded-xl bg-gradient-to-br from-blue-300 via-blue-300 to-indigo-200 p-[4px] shadow-sm transition-all duration-200 ease-out hover:-translate-y-0.5 hover:from-blue-400 hover:via-sky-300 hover:to-blue-400 hover:shadow-md"
>
    <div class="relative min-h-[210px] overflow-hidden rounded-lg bg-white p-5">
        <div class="mb-3 flex items-start gap-3 pr-6">
            <div
                class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-blue-50 to-blue-100 shadow-sm ring-1 ring-blue-100/60 transition-colors duration-200 group-hover:from-blue-100 group-hover:to-blue-200"
            >
                <i class="pi {{ useCase()?.icon }} text-lg text-blue-600"></i>
            </div>

            <div class="min-w-0 flex-1">
                <h3
                    class="text-base font-medium break-words text-gray-900 transition-colors duration-200 group-hover:text-blue-700"
                >
                    {{ useCase()?.title }}
                </h3>
            </div>
        </div>

        <p class="pl-[52px] text-sm leading-relaxed break-words text-gray-600">
            {{ useCase()?.description }}
        </p>
    </div>
</div>
